// extracted by mini-css-extract-plugin
export var main = "news-module--main--1ke8m";
export var header = "news-module--header--lkMc3";
export var title = "news-module--title--1BjY0";
export var image = "news-module--image--2MGwQ";
export var content = "news-module--content--1eePK";